import { generateGradient } from "./color-utils";

export const gradientToBottom = (
  startColor: string,
  endColor: string,
  stepsCount: number
): string => {
  const percentsByStep = 100 / stepsCount;

  return (
    "repeating-linear-gradient(to bottom, " +
    generateGradient(startColor, endColor, stepsCount)
      .reverse()
      .reduce((acc, cur, i) => {
        acc.push(`#${cur} ${i * percentsByStep}%`);
        acc.push(`#${cur} ${(i + 1) * percentsByStep}%`);
        return acc;
      }, [])
      .join(",") +
    ")"
  );
};
